module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scorll"
  }, [_c('div', {
    staticClass: "Home"
  }, [(_vm.totalCount > 0) ? _c('div', {
    staticClass: "oldHome"
  }, [_vm._m(0), _vm._v(" "), (_vm.historyHomework.length) ? _c('div', {
    ref: "viewWrapper",
    staticClass: "historyHomework",
    on: {
      "scroll": function($event) {
        _vm.handleScroll()
      }
    }
  }, [_vm._l((_vm.historyHomework), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_c('history', {
      key: index,
      attrs: {
        "content": item,
        "delIndex": index,
        "PageIndex": _vm.PageIndex
      },
      on: {
        "removeWork": _vm.removeWork
      }
    })], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.totalCount == 0) ? _c('div', {
    staticClass: "newHome"
  }, [_vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("检查作业")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noWorkBox"
  }, [_c('img', {
    staticClass: "noGrade",
    attrs: {
      "src": require("./../assets/img/null.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("您还没有布置过作业呢，赶紧去布置吧")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3912474","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 1242
// module chunks = 1